export class WorkOrderActions {
    static readonly VIEW_OR_EDIT_WORKORDER = 'viewOrEditWorkOrder';
    static readonly VIEW_MAINTENANCE_JOB = 'viewMaintenanceJob';
    static readonly GENERATE_WORK_AUTHORIZATION = 'generateWorkAuthorization';
    static readonly GENERATE_AND_EMAIL_WORK_AUTHORIZATION = 'generateAndEmailWorkAuthorization';
    static readonly EMAIL_LATEST_WORK_AUTHORIZATION = 'emailLatestWorkAuthorization';
    static readonly CHANGE_STATUS = 'changeStatus';
    static readonly MANAGE_WORK_AUTHORIZATION = 'manageWorkAuthorization';
    static readonly MANAGE_PROPOSALS = 'manageProposals';
    static readonly MANAGE_TASK_REFERENCES = 'manageTaskReferences';
    static readonly MANAGE_INVOICE_REFERENCES = 'manageInvoiceReferences';
    static readonly CREATE_MAINTENANCE_JOB = 'createMaintenanceJob';

    static readonly GENERATE = 'generate';
    static readonly GENERATE_AND_EMAIL = 'generateAndEmail';
    static readonly UPLOAD = 'upload';
}
